// extracted by css-extract-rspack-plugin
export default {"wrapper":"YfZv5j9wiBD_sIKo","lineText":"eUK8z6BkdqgvF1aN","wrapTwo":"k7c2hbwbLHInWI_G"};